import { CATEGORY_REDIRECTS } from '../../constants';
import categoryUrl from '../../utils/categoryUrl';

const getEmptyDataRedirect = (params, data, errors) => {
  if (errors && !data) return '/';
  const { categoryName } = params || {};
  if (!data) return false;
  if (!categoryName) return '/';
  const { data: dataArr } = data;

  const [dataObj] = dataArr || [];

  if (!dataObj) return '/';

  const { attributes } = dataObj || {};
  const { name } = attributes || {};

  if (!name) return '/';

  return false;
};

const getCategoryRedirects = params => {
  const { categoryName = '' } = params || {};

  if (!categoryName) return '/';

  const redirectCat = CATEGORY_REDIRECTS[categoryName];

  return redirectCat ? categoryUrl(redirectCat) : false;
};

const redirects = ({ params, data: searchSeoCategory, errors }) => {
  // const { searchSeoCategory } = data || {}; # REVERT GRAPHQL
  const redirectArray = [
    getCategoryRedirects(params),
    getEmptyDataRedirect(params, searchSeoCategory, errors),
  ];

  return redirectArray.find(url => url);
};

export default redirects;
